import "./App.css";
import React from "react";
import CaptchaFrame from "./components/CaptchaFrame";
import "./i18n/i18n";
import { PowWrapper } from "./components/PowWrapper";

export default function App() {
  return (
    <PowWrapper>
      <CaptchaFrame
        apiURL={
          process.env.REACT_APP_CAPTCHA_API_URL ||
          window.location.origin + "/captcha/v1/api"
        }
        width={370}
        height={400}
      />
    </PowWrapper>
  );
}
